var React = require('react');

function Great (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Rectangle_38235","data-name":"Rectangle 38235","fill":"none","stroke":"#bdff3b","strokeWidth":"1","key":0},[React.createElement("rect",{"width":"40","height":"40","rx":"20","stroke":"none","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"39","height":"39","rx":"19.5","fill":"none","key":1})]),React.createElement("rect",{"id":"Rectangle_38236","data-name":"Rectangle 38236","width":"22","height":"22","transform":"translate(9 9)","fill":"none","key":1}),React.createElement("path",{"id":"Path_105469","data-name":"Path 105469","d":"M-2316.82-22045.156l5.05,5.049,9.094-9.094","transform":"translate(2329.32 22064.701)","fill":"none","stroke":"#000","strokeWidth":"1.5","key":2})]);
}

Great.defaultProps = {"id":"great","width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Great;

Great.default = Great;
